import React from "react";
import { ProductRibbon } from "packages/ui-shared/components/ProductRibbon";
import { productCardRibbon } from "./ProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "ribbon" | "image">;
};

export const ProductCardRibbon: React.FC<Props> = ({ product }) => {
  if (!product.ribbon?.ribbonKey || !product.ribbon.text || !product.image?.src)
    return null;

  return (
    <div className={productCardRibbon}>
      <ProductRibbon
        ribbonKey={product.ribbon.ribbonKey}
        text={product.ribbon.text}
      />
    </div>
  );
};
